import React from "react";
import PropTypes from "prop-types";

import Skill from "./Skill";

const Skills = ({ skills, onChangeSkillName, onAddSkill, onDeleteSkill }) => (
  <div className="in-service-skills">
    {skills.length > 0 ? <label>Skills</label> : null}

    <div className="mb-15">
      {skills
        .filter(s => !s._destroy)
        .map(item => (
          <Skill
            key={item.id || item._id}
            skill={item}
            onChange={onChangeSkillName}
            onDelete={onDeleteSkill}
          />
        ))}
    </div>

    <div>
      <button
        className="btn btn-indigo btn-raised btn-long"
        onClick={onAddSkill}
      >
        ADD SKILL
      </button>
    </div>
  </div>
);

Skills.propTypes = {
  skills: PropTypes.array.isRequired,
  onChangeSkillName: PropTypes.func,
  onAddSkill: PropTypes.func,
  onDeleteSkill: PropTypes.func
};

export default Skills;
